import { inject, ResourceRef } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { Organization } from '@sona/shared-model-common';
import { filter, firstValueFrom } from 'rxjs';

import { SonaAuthApiFacade } from '../facades/auth-api.facade';

export const isOrganizationOwnerGuard = (): CanActivateFn => {
    return async (route) => {
        const authFacade = inject(SonaAuthApiFacade);

        const userId = authFacade.user()?.id;

        if (!authFacade.organization.hasValue()) {
            await firstValueFrom(toObservable((authFacade.organization as ResourceRef<Organization>).isLoading)
                .pipe(filter((loading) => !loading)));
        }

        const organizationOwnerId = authFacade.organization.value()?.ownerId;

        if (!userId || !organizationOwnerId || userId !== organizationOwnerId) {
            return createUrlTreeFromSnapshot(route, [ '/forbidden' ]);
        }

        return true;
    };
};
